import React, { useRef, useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import i18n from '../../../app/i18n';

import TileComponent from '../../../shared/TileComponent';
import { Button } from '../../../shared/FormStyles/Button';

const ButtonContainer = styled.div`
  background-color: ${themeGet('colors.background')};
`;

const StyledDiv = styled.div`
  text-align: center;
`;

const TileWall = styled.div`
  margin: 0 auto;
  width: ${({ width }) => `${width}px`};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const TileWallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const tileTypeDisplay = ['incomplete', 'complete'];

const calculateWidth = refWidth => {
  const tileWidth = 280;
  const columns = Math.floor(refWidth / tileWidth);

  return columns >= 4 ? 4 * tileWidth : columns * tileWidth;
};

const TilesInOrder = ({ tiles, order, openTileModal, type }) =>
  order.map(tileId => (
    <TileComponent
      id={tileId}
      key={tileId}
      tileThumblinkOnClick={() => {
        openTileModal(tileId);
      }}
      thumbnail={tiles[tileId].imagePath}
      tileThumbnailClass={type === 'complete' ? 'completed' : 'incomplete'}
      {...tiles[tileId]}
    />
  ));

const TileWallComponent = props => {
  const [width, setWidth] = useState(0);
  const ref = useRef(null);
  const observer = useRef(
    new ResizeObserver(entries => {
      requestAnimationFrame(() => {
        const { width: contentWidth } = entries[0].contentRect;

        setWidth(contentWidth);
      });
    }),
  );

  useEffect(() => {
    const { current: observerRef } = observer;
    const { current: tileWallWrapperRef } = ref;

    if (tileWallWrapperRef) {
      observerRef.observe(tileWallWrapperRef);
    }

    return () => {
      observerRef.unobserve(tileWallWrapperRef);
    };
  }, []);

  return (
    <TileWallWrapper ref={ref}>
      <TileWall width={calculateWidth(width)}>
        {tileTypeDisplay.map((type, index) => (
          <TilesInOrder
            key={index}
            tiles={props.tiles[type]}
            order={props.tiles[type].order}
            openTileModal={props.openTileModal}
            type={type}
          />
        ))}
      </TileWall>

      {!props.allTilesDisplayed && (
        <StyledDiv id="tile_links">
          <ButtonContainer className="more_tiles_button">
            <Button
              variant="tertiary"
              className="show_more_tiles"
              onClick={props.loadMoreTiles}
            >
              {props.loadingMoreTiles ? (
                <i
                  className="fa-solid fa-spinner fa-spin fa-fw"
                  id="show_more_tiles_spinner"
                ></i>
              ) : (
                <span className="show_more_tiles_copy">
                  {i18n.t('activityBoard:tileWall.loadButton')}
                </span>
              )}
            </Button>
          </ButtonContainer>
        </StyledDiv>
      )}
    </TileWallWrapper>
  );
};

TileWallComponent.propTypes = {
  tiles: PropTypes.shape({
    complete: PropTypes.object,
    incomplete: PropTypes.object,
  }),
  allTilesDisplayed: PropTypes.bool,
  openTileModal: PropTypes.func,
  loadMoreTiles: PropTypes.func,
  loadingMoreTiles: PropTypes.bool,
};

export default TileWallComponent;
